<template>
  <div>
    
    <el-row>
      <el-col :span="6">
        <span class="dash-value dash-num-blue" >{{totalCount}}</span>&nbsp;
        <span class="dash-title">{{$t('payReport.totalCount')}}</span>
      </el-col>
      <el-col :span="18">
        <SearchCriterial
          :handleReset="handleReset"
          :searchParams="searchParams"
          :handleChangeSearchParams="handleChangeSearchParams"
          :handleSearch="handleSearch"
        />
      </el-col>
    </el-row>
    
    <el-table :data="items" style="width: 100%;padding: 10px 10px 10px 10px;">
      <el-table-column prop="month" :label="$t('payReport.month')"> </el-table-column>
      <el-table-column prop="functionName" :label="$t('payReport.functionName')"> </el-table-column>
      <el-table-column prop="currentPlan" :label="$t('payReport.currentPlan')"> </el-table-column>
      <el-table-column prop="extraFee" :label="$t('payReport.extraFee')">
        <template slot-scope="scope">
          <span class="dash-num-blue">{{scope.row.extraFee}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalFee" :label="$t('payReport.totalFee')">
        <template slot-scope="scope">
          <span v-if="scope.row.totalFee <=0" class="dash-num-blue">{{scope.row.totalFee}}</span>
          <span class="dash-num-orange" v-else>+{{scope.row.totalFee}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="balance" :label="$t('payReport.balance')">
        <template slot-scope="scope">
          <span class="dash-num-blue"><b>{{scope.row.balance}}</b></span>
        </template>
      </el-table-column>
      <el-table-column prop="date" :label="$t('payReport.date')"> </el-table-column>
    </el-table>
    <PageBar>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalCount"
        @current-change="handleCurrentChange"
        :current-page.sync="searchParams.pageIndex"
        :page-size="searchParams.pageSize"
      >
      </el-pagination>
    </PageBar>
  </div>
</template>

<script>
import SearchCriterial from "@/components/pay/payReport/SearchCriterial.vue";
import PageBar from "@/components/common/PageBar.vue";
import { bill } from "@/api/pay";
import { mapState } from "vuex";
const defaultSearchParams = {
  searchType: "",
  pageIndex: 1,
  pageSize: 10
};
export default {
  name: "PayReport",
  components: { SearchCriterial, PageBar },
  data: () => {
    return {      
      searchParams: {...defaultSearchParams},
      totalCount: 0,
      items: []
    };
  },
  mounted() {
    this.refreshData();
  },
  computed: {
    ...mapState(["accountInfo"])
  },
  methods: {
    refreshData() {
      bill({
        userID: this.accountInfo.userID,
        ...this.searchParams
      }).then(response => {
        this.totalCount = response.data.totalCount;
        this.items = response.data.items;
      });
    },
    handleCurrentChange(val) {
      this.searchParams = { ...this.searchParams, pageIndex: val };
      this.refreshData();
    },
    handleChangeSearchParams(searchParams) {
      this.searchParams = searchParams;
    },
    handleSearch() {
      this.searchParams = { ...this.searchParams, pageIndex: 1 };
      this.refreshData();
    },
    handleReset() {
      this.searchParams = {...defaultSearchParams};
      this.refreshData();
    }
  }
};
</script>
